import React, { useState } from 'react';
import { Link } from 'react-router-dom';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faBars, faXmark } from '@fortawesome/free-solid-svg-icons';

export default function Header() {
  const [isMenuOpen, setIsMenuOpen] = useState(false);

  const closeMenu = () => setIsMenuOpen(false);

  return (
    <header className="site-header">
      <nav className="site-nav">
        <Link to="/" className="site-logo-link" onClick={closeMenu}>
          <img src="/LOGO%20TM%205.svg" alt="ClickMob logo" className="site-logo" />
        </Link>

        <button
          type="button"
          className="menu-toggle"
          aria-label={isMenuOpen ? 'Fechar menu' : 'Abrir menu'}
          aria-expanded={isMenuOpen}
          aria-controls="primary-menu"
          onClick={() => setIsMenuOpen((open) => !open)}
        >
          <FontAwesomeIcon icon={isMenuOpen ? faXmark : faBars} />
        </button>

        <ul id="primary-menu" className={`nav-menu ${isMenuOpen ? 'nav-menu-open' : ''}`}>
          <li className="nav-item">
            <Link to="/" className="nav-link" onClick={closeMenu}>Home</Link>
          </li>
          <li className="nav-item">
            <Link to="/sobre" className="nav-link" onClick={closeMenu}>Sobre</Link>
          </li>
          <li className="nav-item">
            <Link to="/como-funciona" className="nav-link" onClick={closeMenu}>Como Funciona</Link>
          </li>
          <li className="nav-item">
            <Link to="/nossosdiferenciais" className="nav-link" onClick={closeMenu}>Nossos Diferenciais</Link>
          </li>
          <li className="nav-item">
            <Link to="/quemsomos" className="nav-link" onClick={closeMenu}>Quem Somos</Link>
          </li>
          <li className="nav-item">
            <Link to="/contato" className="nav-link" onClick={closeMenu}>Contato</Link>
          </li>
        </ul>
      </nav>
      <div className="site-header-elevation" aria-hidden="true" />
    </header>
  );
}
